module.exports = " <div id=app _v-372cc35b=\"\"> <p _v-372cc35b=\"\"> Welcome to your Vue.js app with dropzone! </p> <dropzone ref=myUniqueID param-name=something id=myVueDropzone url=https://httpbin.org/post v-on:vdropzone-success=success _v-372cc35b=\"\"></dropzone> <button v-on:click=processFiles _v-372cc35b=\"\">Upload the things</button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-372cc35b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 10
 ** module chunks = 0
 **/